const React = require('react');
const T = require('prop-types');
const { NavLink: Link } = require('react-router-dom');

const ConsoleTheme = require('utils/console-theme');
const TeamConsoleDependencies = require('../team-console-dependencies');

const { NerpyIcon } = ConsoleTheme;
const styles = ConsoleTheme.createTeamConsoleStyles();

const TeamConsole = function TeamConsole(props) {

    const model = TeamConsoleDependencies.getTeamConsoleModel(props);

    return (
        <main style={styles.page} aria-label='Nearpeer team console'>
            <section style={styles.hero}>
                <div style={styles.brand}>
                    <img src={NerpyIcon} alt='' style={styles.nerpy} />
                    <div>
                        <div style={styles.eyebrow}>Nearpeer Team Console</div>
                        <h1 style={styles.title}>Community operations</h1>
                        <p style={styles.description}>
                            A safe workspace for team members who help manage communities.
                        </p>
                    </div>
                </div>
                <div style={styles.scopeCard}>
                    <div style={styles.scopeLabel}>Scope</div>
                    <div style={styles.scopeValue}>{model.access.schoolScopeLabel}</div>
                    <div style={styles.scopeMeta}>
                        {model.access.visibleSchoolCount} visible school{model.access.visibleSchoolCount === 1 ? '' : 's'}
                    </div>
                </div>
            </section>

            <section style={styles.grid} aria-label='Team console summary'>
                <Metric label='Dashboard' enabled={model.capabilities.dashboard} />
                <Metric label='Messaging' enabled={model.capabilities.batchNotify} />
                <Metric label='Preapproval' enabled={model.capabilities.preapprove} />
                <Metric label='Groups' enabled={model.capabilities.groups} />
                <Metric label='Surveys' enabled={model.capabilities.surveys} />
            </section>

            <section style={styles.section}>
                <h2 style={styles.sectionTitle}>Actions</h2>
                <div style={styles.actionsGrid}>
                    {model.actions.map((action) => (
                        <Link
                            key={action.id}
                            to={action.path}
                            style={styles.actionCard}
                            data-focus-outline='radius:16,padding:4'
                        >
                            <span style={styles.actionLabel}>{action.label}</span>
                            <span style={styles.actionDescription}>{action.description}</span>
                        </Link>
                    ))}
                    {!model.actions.length && (
                        <div style={styles.empty}>
                            No team-console actions are available for your current role.
                        </div>
                    )}
                </div>
            </section>

            <section style={styles.section}>
                <h2 style={styles.sectionTitle}>Current operator</h2>
                <dl style={styles.details}>
                    <Row label='Email' value={model.currentUser.email || '-'} />
                    <Row label='School' value={model.currentSchool?.name || '-'} />
                    <Row label='School ID' value={model.currentUser.schoolId || '-'} />
                    <Row label='All-school access' value={model.access.canViewAllSchools ? 'Yes' : 'No'} />
                </dl>
            </section>
        </main>
    );
};

module.exports = TeamConsole;

function Metric({ label, enabled }) {

    return (
        <div style={enabled ? styles.metricEnabled : styles.metricDisabled}>
            <span style={styles.metricLabel}>{label}</span>
            <strong style={styles.metricValue}>{enabled ? 'Available' : 'Unavailable'}</strong>
        </div>
    );
}

function Row({ label, value }) {

    return (
        <div style={styles.row}>
            <dt style={styles.rowLabel}>{label}</dt>
            <dd style={styles.rowValue}>{value}</dd>
        </div>
    );
}

Metric.propTypes = {
    label: T.string.isRequired,
    enabled: T.bool
};

Row.propTypes = {
    label: T.string.isRequired,
    value: T.oneOfType([
        T.string,
        T.number
    ])
};

TeamConsole.propTypes = {
    ...TeamConsoleDependencies.dependencyPropTypes
};

